var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Modal, Button, Spin } from 'antd';
import { CameraOutlined, DeleteOutlined, UploadOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useCameraCapture } from './useCameraCapture';
import { blobToJpegFile } from './attachmentFilename';
/** Built names assume .jpg; picked files keep their real type. */
var nameForPickedFile = function (builtName, picked) {
    var isPng = picked.type === 'image/png' || /\.png$/i.test(picked.name);
    return isPng ? builtName.replace(/\.jpg$/i, '.png') : builtName;
};
export var CameraCaptureModal = function (_a) {
    var visible = _a.visible, title = _a.title, buildFileName = _a.buildFileName, onCancel = _a.onCancel, onConfirm = _a.onConfirm, _b = _a.confirmLoading, confirmLoading = _b === void 0 ? false : _b, confirmText = _a.confirmText;
    var t = useTranslation().t;
    var _c = useState([]), shots = _c[0], setShots = _c[1];
    var _d = useState(false), isFlashing = _d[0], setIsFlashing = _d[1];
    var _e = useState(false), isSubmitting = _e[0], setIsSubmitting = _e[1];
    var fileInputRef = useRef(null);
    var _f = useCameraCapture(visible), videoRef = _f.videoRef, canvasRef = _f.canvasRef, cameras = _f.cameras, deviceId = _f.deviceId, isReady = _f.isReady, isStarting = _f.isStarting, errorCode = _f.errorCode, startCamera = _f.startCamera, capture = _f.capture;
    var isBusy = confirmLoading || isSubmitting;
    useEffect(function () {
        if (visible)
            return;
        setShots(function (current) {
            current.forEach(function (shot) { return URL.revokeObjectURL(shot.url); });
            return [];
        });
    }, [visible]);
    var handleCapture = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var blob;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, capture()];
                case 1:
                    blob = _a.sent();
                    if (!blob)
                        return [2 /*return*/];
                    setIsFlashing(true);
                    window.setTimeout(function () { return setIsFlashing(false); }, 150);
                    setShots(function (current) {
                        var file = blobToJpegFile(blob, buildFileName(current.length));
                        return __spreadArray(__spreadArray([], current, true), [{ id: Date.now() + "-" + current.length, file: file, url: URL.createObjectURL(file) }], false);
                    });
                    return [2 /*return*/];
            }
        });
    }); }, [buildFileName, capture]);
    var handlePickFiles = useCallback(function (event) {
        var picked = Array.from(event.target.files || []);
        picked.forEach(function (file, offset) {
            setShots(function (current) {
                var builtName = buildFileName(current.length);
                var renamed = new File([file], nameForPickedFile(builtName, file), {
                    type: file.type || 'image/jpeg'
                });
                return __spreadArray(__spreadArray([], current, true), [
                    {
                        id: Date.now() + "-" + current.length + "-" + offset,
                        file: renamed,
                        url: URL.createObjectURL(renamed)
                    }
                ], false);
            });
        });
        // Allow picking the same file again after a removal.
        event.target.value = '';
    }, [buildFileName]);
    var removeShot = useCallback(function (shot) {
        URL.revokeObjectURL(shot.url);
        setShots(function (current) { return current.filter(function (item) { return item.id !== shot.id; }); });
    }, []);
    var handleConfirm = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!shots.length || isBusy)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    setIsSubmitting(true);
                    return [4 /*yield*/, onConfirm(shots.map(function (shot) { return shot.file; }))];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    setIsSubmitting(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [isBusy, onConfirm, shots]);
    var errorMessage = function (code) {
        if (code === 'denied') {
            return t('Camera permission was blocked. Allow camera access, then try again.');
        }
        if (code === 'unsupported') {
            return t('Camera is not available here. Attach a photo from this device instead.');
        }
        return t('Could not start the camera. Check that it is connected and not in use.');
    };
    return (_jsx(Modal, __assign({ title: title || t('Add Photo'), visible: visible, width: '90%', style: { maxWidth: '900px' }, onCancel: function () {
            if (isBusy)
                return;
            onCancel();
        }, maskClosable: !isBusy, keyboard: !isBusy, footer: [
            _jsx(Button, __assign({ onClick: onCancel, disabled: isBusy }, { children: t('Cancel') }), 'cancel'),
            _jsxs(Button, __assign({ type: 'primary', onClick: handleConfirm, loading: isBusy, disabled: !shots.length }, { children: [confirmText || t('Attach Photos'), shots.length > 0 ? " (" + shots.length + ")" : ''] }), 'confirm')
        ] }, { children: _jsxs("div", __assign({ className: 'flex flex-col gap-4 lg:flex-row' }, { children: [_jsxs("div", __assign({ className: 'w-full lg:w-7/12' }, { children: [_jsxs("div", __assign({ className: 'relative flex items-center justify-center overflow-hidden rounded-lg bg-black', style: { minHeight: '220px' } }, { children: [_jsx("video", { ref: videoRef, playsInline: true, muted: true, className: 'w-full', style: { maxHeight: '340px', display: isReady ? 'block' : 'none' }, "aria-label": String(t('Live camera preview')) }, void 0), _jsx("canvas", { ref: canvasRef, style: { display: 'none' } }, void 0), isFlashing && _jsx("div", { className: 'absolute inset-0 bg-white opacity-70' }, void 0), !isReady && (_jsx("div", __assign({ className: 'flex flex-col items-center justify-center p-6 text-center text-white' }, { children: isStarting ? (_jsxs(_Fragment, { children: [_jsx(Spin, {}, void 0), _jsx("p", __assign({ className: 'mt-3 text-sm' }, { children: t('Opening camera') }), void 0)] }, void 0)) : (_jsxs(_Fragment, { children: [_jsx(CameraOutlined, { style: { fontSize: '28px' } }, void 0), _jsx("p", __assign({ className: 'mt-3 text-sm' }, { children: errorMessage(errorCode) }), void 0), errorCode !== 'unsupported' && (_jsx(Button, __assign({ size: 'small', className: 'mt-3', onClick: function () { return startCamera(deviceId || undefined); } }, { children: t('Try again') }), void 0))] }, void 0)) }), void 0))] }), void 0), _jsxs("div", __assign({ className: 'mt-3 flex flex-wrap items-center gap-3' }, { children: [_jsx(Button, __assign({ type: 'primary', icon: _jsx(CameraOutlined, {}, void 0), onClick: handleCapture, disabled: !isReady || isBusy }, { children: t('Take Photo') }), void 0), _jsx(Button, __assign({ icon: _jsx(UploadOutlined, {}, void 0), onClick: function () { var _a; return (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click(); }, disabled: isBusy }, { children: t('Attach from device') }), void 0), _jsx("input", { ref: fileInputRef, type: 'file', accept: 'image/jpeg,image/png', multiple: true, style: { display: 'none' }, onChange: handlePickFiles }, void 0), cameras.length > 1 && (_jsx("select", __assign({ className: 'rounded border border-gray-300 px-2 py-1 text-xs', value: deviceId, onChange: function (event) { return startCamera(event.target.value); }, disabled: isBusy, "aria-label": String(t('Select camera')) }, { children: cameras.map(function (camera) { return (_jsx("option", __assign({ value: camera.deviceId }, { children: camera.label }), camera.deviceId)); }) }), void 0))] }), void 0)] }), void 0), _jsxs("div", __assign({ className: 'w-full lg:w-5/12' }, { children: [_jsxs("p", __assign({ className: 'mb-2 text-xs font-bold text-gray-700' }, { children: [t('Photos'), " (", shots.length, ")"] }), void 0), shots.length === 0 ? (_jsx("div", __assign({ className: 'flex items-center justify-center rounded-lg border border-dashed border-gray-300 p-6 text-center text-xs text-gray-400', style: { minHeight: '120px' } }, { children: t('No photos yet') }), void 0)) : (_jsx("div", __assign({ className: 'space-y-2 overflow-y-auto', style: { maxHeight: '340px' } }, { children: shots.map(function (shot) { return (_jsxs("div", __assign({ className: 'flex items-center gap-2 rounded border border-gray-200 p-2' }, { children: [_jsx("img", { src: shot.url, alt: String(t('Captured photo')), className: 'rounded object-cover', style: { width: '56px', height: '56px' } }, void 0), _jsx("p", __assign({ className: 'min-w-0 flex-1 truncate text-xxs text-gray-600' }, { children: shot.file.name }), void 0), _jsx("button", __assign({ type: 'button', onClick: function () { return removeShot(shot); }, disabled: isBusy, className: 'flex items-center justify-center rounded p-1 text-gray-500 hover:bg-gray-100', title: String(t('Delete')) }, { children: _jsx(DeleteOutlined, {}, void 0) }), void 0)] }), shot.id)); }) }), void 0))] }), void 0)] }), void 0) }), void 0));
};
export default CameraCaptureModal;
